import {
  IDTF_PATIENTS_DATA_REQUEST,
  IDTF_PATIENTS_DATA_SUCCESS,
  IDTF_PATIENTS_DATA_FAILURE,
  IDTF_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT,
  IDTF_PATIENTS_AUTO_COMPLETE_DATA_SUCCESS,
} from './types';

const initialState = {
  patients: {
    isFetching: false,
    data: [],
    error: {},
    dataLastUpdated: new Date(),
  },
  filterDropdownlist: {
    isFetching: false,
    data: [
      {
        id: 1,
        label: 'Patient',
      },
    ],
    error: {},
  },
  selectedvalueOnSubmit: {},
  kardiaRxAutoCompleteSearch: {},
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [IDTF_PATIENTS_DATA_REQUEST]: (state, action) => ({
    ...state,
    patients: {
      isFetching: true,
      data: [],
      error: {},
      dataLastUpdated: new Date(),
    },
  }),
  [IDTF_PATIENTS_DATA_SUCCESS]: (state, action) => ({
    ...state,
    patients: {
      isFetching: false,
      data: action.payload,
      error: {},
      dataLastUpdated: new Date(),
    },
  }),
  [IDTF_PATIENTS_AUTO_COMPLETE_DATA_SUCCESS]: (state, action) => ({
    ...state,
    kardiaRxAutoCompleteSearch: action.payload[0].map(item => {
      return {
        customParticipantID: item.mrn,
        firstName: item.patientFirstName,
        lastName: item.patientLastName,
        id: item.participantId,
        // id
      };
    }),
  }),
  [IDTF_PATIENTS_DATA_FAILURE]: (state, action) => ({
    ...state,
    patients: {
      isFetching: false,
      data: [],
      error: 'failed',
      dataLastUpdated: new Date(),
    },
  }),
  [IDTF_PATIENTST_FILTER_DROPDOWN_VALUE_SUBMIT]: (state, action) => ({
    ...state,
    selectedvalueOnSubmit: action.payload,
  }),
  // [CLEAR_STATE]: (state, action) => ({ ...initialState }),
};

//
// Reducer
// ------------------------------------
export const KardiaRxIDTFPatient = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/views/state/kardiaRxIdtf/KardiaRxIDTFPatientsReducers.js